import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PropertyMap } from '../../order/interface/order.interface';
import { Scenario, ScenarioMap } from '../interface/scenario.interface';

@Injectable({
  providedIn: 'root',
})
export class ScenarioState {
  constructor() {}

  /** Stores full list of scenarios as a map of an active order */
  private _scenarioMapSub$: BehaviorSubject<ScenarioMap | null> = new BehaviorSubject<ScenarioMap | null>(null);
  scenarioMap$: Observable<ScenarioMap | null> = this._scenarioMapSub$.asObservable();

  get scenarioMap(): ScenarioMap | null {
    return this._scenarioMapSub$.value;
  }

  set scenarioMap(value: ScenarioMap | null) {
    this._scenarioMapSub$.next(value);
  }

  /**Store details of active scenario */
  private _activeScenarioSub$ = new BehaviorSubject<Scenario | null>(null);
  activeScenario$: Observable<Scenario | null> = this._activeScenarioSub$.asObservable();

  get activeScenario(): Scenario | null {
    return this._activeScenarioSub$.value;
  }

  set activeScenario(value: Scenario | null) {
    this._activeScenarioSub$.next(value);
  }

  /**
   * Stores all the selected comparable for all the Scenarios that have been fetched to the FE.
   * The /getSelectedComparables API will store the comps of each Scenario in this state.
   */
  private _allScenarioSelectedCompsMapSub$ = new BehaviorSubject<Record<string, PropertyMap> | null>(null);

  get allScenarioSelectedCompsMap$(): Record<string, PropertyMap> | null {
    return this._allScenarioSelectedCompsMapSub$.value;
  }

  set allScenarioSelectedCompsMap$(value: Record<string, PropertyMap> | null) {
    this._allScenarioSelectedCompsMapSub$.next(value);
  }
}
